import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { Task } from '../../models/taskService.model';

export default function useTasks(): Task[] {
  const selectedCommunity = useSelector((state: RootState) => state.application.selectedCommunity);
  const taskMap = useSelector((state: RootState) => state.tasks.taskMap);

  return taskMap[selectedCommunity!] || [];
}
